webpackJsonp([0],{

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(542)
}
var Component = __webpack_require__(139)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(545),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6b016496",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  methods: {
    goback: function goback() {
      window.history.go(-1);
    },
    gohome: function gohome() {
      window.location.href = '/';
    }
  }
};

/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(528)(true);
// imports


// module
exports.push([module.i, ".error-page-container[data-v-6b016496]{width:920px;margin:200px auto}.error-page-container .left-part[data-v-6b016496]{float:left;margin-right:50px}.error-page-container .right-part[data-v-6b016496]{float:left}.error-page-container .right-part .text[data-v-6b016496]{font-size:22px;margin-top:30px;color:#353535}.error-page-container .right-part .back-btn[data-v-6b016496]{margin-top:60px}", "", {"version":3,"sources":["/home/aisp/workspace/aife/independent-source-codes/errors/src/views/404.vue"],"names":[],"mappings":"AACA,uCACE,YAAa,AACb,iBAAmB,CACpB,AACD,kDACE,WAAY,AACZ,iBAAmB,CACpB,AACD,mDACE,UAAY,CACb,AACD,yDACE,eAAgB,AAChB,gBAAiB,AACjB,aAAe,CAChB,AACD,6DACE,eAAiB,CAClB","file":"404.vue","sourcesContent":["\n.error-page-container[data-v-6b016496] {\n  width: 920px;\n  margin: 200px auto;\n}\n.error-page-container .left-part[data-v-6b016496] {\n  float: left;\n  margin-right: 50px;\n}\n.error-page-container .right-part[data-v-6b016496] {\n  float: left;\n}\n.error-page-container .right-part .text[data-v-6b016496] {\n  font-size: 22px;\n  margin-top: 30px;\n  color: #353535;\n}\n.error-page-container .right-part .back-btn[data-v-6b016496] {\n  margin-top: 60px;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(539);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(529)("1ac41fad", content, true, null);

/***/ }),

/***/ 545:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "error-page-container"
  }, [_c('img', {
    staticClass: "left-part",
    attrs: {
      "src": "static/img/404.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right-part"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("抱歉，您访问的链接地址有误，请重新查找或刷新页面试一试！")]), _vm._v(" "), _c('el-button', {
    staticClass: "back-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.gohome()
      }
    }
  }, [_vm._v("返回首页")])], 1)])])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.9a16acb3c1b221441295.js